const m = 5, r = {
  one: 10
};
var a = /* @__PURE__ */ ((l) => (l.ExtraSmall = "extra-small", l.Small = "small", l.Medium = "medium", l))(a || {});
export {
  r as Decimal,
  m as MAX_SCORE,
  a as SizesEnum
};
